export function formatTime(minutes: number): string {
    if (minutes === undefined) return '';
    const hours = Math.floor(minutes / 60);
    if (hours > 72 && false) {
        return `${Math.floor(hours / 24)}d${(hours % 24).toString().padStart(2, '0')}h`;
    }
    if (hours > 72) {
        // show only hours
        return `${hours}h`;
    }
    const remainingMinutes = Math.floor(minutes % 60);
    return `${hours}h${remainingMinutes.toString().padStart(2, '0')}`;
}
